import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import HelperValidate from 'utils/helper-validate'

const selectEmployeeLanguage = createSelector(
	[
		(state) => {
			return state.data[dataConstants.EMPLOYEE];
		}
	],
	( employee ) => {
		return HelperValidate.isValid( employee?.language ) ? employee?.language : { guid: 'nlnl', code: 'nl-NL' }
	}
)

export default selectEmployeeLanguage;
